import { Component, Vue, Prop } from 'vue-property-decorator';
import { VueConstructor, CreateElement, VNodeData, VNode } from 'vue';

@Component
export default class ClDialogContent extends Vue {
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  @Prop({
    type: [String, Function],
    default: 'div'
  })
  public component!: string | VueConstructor<Vue>;

  render(h: CreateElement): VNode {
    const componentData: VNodeData = {
      class: {
        'cl-dialog-content': true
      },
      on: this.$listeners
    };
    return h(this.component, componentData, this.$slots.default);
  }
}
